// Hilfetexte zu den Prüfpunkten – Teil 1 (Module 01-STATIONSKOERPER, 02-MS-ANLAGE, 03-NSHV)
//
// Werden über den kleinen „i"-Knopf am Prüfpunkt angezeigt. Ziel: Auch ein Azubi
// soll verstehen, was geprüft wird, worauf zu achten ist und wann n.i.O. zu wählen ist.
//
// Geschrieben am 13.09.2026 – ENTWURF, muss vom Büro fachlich gegengelesen werden.
// Normen ohne Abschnittsnummern, außer die Nummer steht schon in der ETB-Vorlage.
//
// Schlüssel: `${modulCode}|${pos}` – pos genau wie in der Prüfpunkt-Vorlage.
// Felder: was (was wird geprüft), achten (typische Mängel), nio (wann n.i.O.), norm.

export const MODUL_INFO_TEIL1 = {
  '01-STATIONSKOERPER':
    'Baulicher Zustand der Station von außen und innen: Wände, Dach, Türen, Boden, Lüftung, Fenster und Beleuchtung. Reine Sicht- und Funktionsprüfung, ohne Arbeiten an spannungsführenden Teilen.',
  '02-MS-ANLAGE':
    'Sichtprüfung der Mittelspannungs-Schaltanlage von außen. Geöffnet oder geschaltet wird nur mit Befugnis und Freigabe des Anlagenverantwortlichen, dann nach den fünf Sicherheitsregeln: freischalten, gegen Wiedereinschalten sichern, Spannungsfreiheit feststellen, erden und kurzschließen, benachbarte unter Spannung stehende Teile abdecken oder abschranken.',
  '03-NSHV':
    'Sicht- und Funktionsprüfung der Niederspannungs-Hauptverteilung: Schaltgeräte, Einstellung des Trafo-Leistungsschalters, Alter der Anlage und Überspannungsschutz. Berührungsschutz nicht entfernen, solange die Anlage unter Spannung steht.',
};

export const INFO_TEIL1 = {
  // ───────────── 01-STATIONSKOERPER ─────────────

  // 01.1 Außenwände / Baukörper
  '01-STATIONSKOERPER|01.1': {
    was: 'Außenwände und Sockel des Stationsgebäudes rundum auf Risse, Abplatzungen, Rost und sonstige Schäden ansehen.',
    achten: [
      'Risse im Beton, besonders an Ecken, Tür- und Lüftungsöffnungen',
      'Abgeplatzter Beton mit sichtbarer, rostender Bewehrung',
      'Rost an Blechverkleidungen, Sockeln oder Befestigungen',
      'Setzungen: Station steht schief, Spalt zum Fundament',
    ],
    nio: 'n.i.O., wenn Risse, Abplatzungen, Korrosion oder Beschädigungen über reine Oberflächen-Haarrisse hinausgehen.',
    norm: 'DIN EN 62271-202 (VDE 0671-202) bei Fertigstationen; Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.1.1': {
    was: 'Wände innen und außen auf Feuchte, Schimmel und Salpeter (weiße, krümelige Ausblühungen) prüfen.',
    achten: [
      'Dunkle, feuchte Flecken oder Wasserränder an Wänden',
      'Schimmel (schwarz/grün), muffiger Geruch im Innenraum',
      'Weiße Salzausblühungen (Salpeter) im Sockelbereich',
    ],
    nio: 'n.i.O., wenn Feuchtigkeitsspuren, Schimmel oder Salpeter sichtbar sind.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.1.2': {
    was: 'Außenflächen auf Graffiti, Aufkleber, Plakate und fremde Beschriftungen prüfen.',
    achten: [
      'Graffiti oder Plakate, die Warnschilder oder Kennzeichnungen verdecken',
      'Fremde Aufschriften, die mit Stationsbezeichnungen verwechselt werden können',
      'Aufkleber auf Lüftungsgittern oder Türen',
    ],
    nio: 'n.i.O., wenn Graffiti, unzulässige Beschriftung oder Plakatierung vorhanden ist.',
    norm: 'Kennzeichnung nach DIN VDE 0105-100; ETB-Vorgabe',
  },
  '01-STATIONSKOERPER|01.1.3': {
    was: 'Fugen, Kabel- und Rohrdurchführungen sowie Anschlüsse zwischen Bauteilen auf Dichtheit prüfen.',
    achten: [
      'Offene oder ausgewaschene Fugen zwischen Wand, Dach und Boden',
      'Undichte Kabeleinführungen, Wasser oder Erdreich im Kabelkeller',
      'Fehlende oder spröde Dichtmasse an Wanddurchführungen',
    ],
    nio: 'n.i.O., wenn an Fugen oder Durchführungen Wasser, Erdreich oder Tiere eindringen können.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.1.4': {
    was: 'Baukörper auf Schäden durch Wetter (Frost, Sturm, Wurzeln) oder von außen (Anfahrschaden, Vandalismus) prüfen.',
    achten: [
      'Anfahrschäden durch Fahrzeuge, fehlender Anfahrschutz',
      'Wurzeln oder Bewuchs, die Wand oder Fundament beschädigen',
      'Frostschäden, lose Verkleidungsteile',
    ],
    nio: 'n.i.O., wenn Schäden durch Witterung oder Fremdeinwirkung erkennbar sind.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },

  // 01.2 Dach
  '01-STATIONSKOERPER|01.2.1': {
    was: 'Dach bzw. Dachhaut von außen (soweit gefahrlos einsehbar) und die Decke von innen auf Undichtigkeiten prüfen.',
    achten: [
      'Wasserflecken oder Tropfspuren an der Decke innen',
      'Risse, Blasen oder Löcher in der Dachabdichtung',
      'Moos- oder Pflanzenbewuchs auf dem Dach',
    ],
    nio: 'n.i.O., wenn das Dach undicht ist oder die Dachhaut sichtbar beschädigt ist.',
    norm: 'Herstellerangaben; DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.2.2': {
    was: 'Dach auf Schäden durch Sturm, Hagel, herabfallende Äste oder mutwillige Beschädigung prüfen.',
    achten: [
      'Abgehobene oder fehlende Dachteile',
      'Äste oder Fremdkörper auf dem Dach',
      'Dellen, Löcher, Spuren von Begehung oder Vandalismus',
    ],
    nio: 'n.i.O., wenn Schäden durch Witterung oder Fremdeinwirkung am Dach vorhanden sind.',
    norm: 'Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.2.3': {
    was: 'Dachränder, Abdeckbleche, Rinnen und Wasserabläufe auf Zustand und freien Abfluss prüfen.',
    achten: [
      'Verstopfte Rinnen oder Abläufe (Laub, Schmutz)',
      'Lose, verbogene oder rostige Dachabschlussbleche',
      'Wasser läuft an der Fassade oder über der Tür herunter',
    ],
    nio: 'n.i.O., wenn Dachabschlüsse beschädigt sind oder Wasser nicht ungehindert abläuft.',
    norm: 'Herstellerangaben',
  },

  // 01.3 Türen
  '01-STATIONSKOERPER|01.3.1': {
    was: 'Alle Stationstüren öffnen und schließen: Scharniere und Schließmechanismus müssen leichtgängig und sicher funktionieren.',
    achten: [
      'Tür schleift, klemmt oder fällt nicht von selbst ins Schloss',
      'Ausgeschlagene, rostige oder lose Scharniere',
      'Tür lässt sich nicht vollständig schließen',
    ],
    nio: 'n.i.O., wenn eine Tür nicht leichtgängig öffnet oder nicht sicher schließt.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.3.2': {
    was: 'Schlösser mit dem Schlüssel betätigen: Schließzylinder und Riegel müssen leicht gängig sein.',
    achten: [
      'Schlüssel geht schwer oder nur mit Gewalt',
      'Verrosteter, verschmutzter oder vereister Zylinder',
      'Riegel greift nicht richtig ins Schließblech',
    ],
    nio: 'n.i.O., wenn ein Schloss schwergängig, beschädigt oder nicht sicher verschließbar ist.',
    norm: 'DIN VDE 0105-100 (Anlage gegen Zutritt Unbefugter sichern)',
  },
  '01-STATIONSKOERPER|01.3.3': {
    was: 'Von innen prüfen, ob sich die Tür jederzeit ohne Schlüssel öffnen lässt (Notentriegelung / Panikschloss).',
    achten: [
      'Tür lässt sich von innen nicht ohne Schlüssel öffnen',
      'Panikgriff oder Notentriegelung fehlt, klemmt oder ist blockiert',
      'Tür öffnet nicht in Fluchtrichtung (nach außen)',
    ],
    nio: 'n.i.O., wenn die Tür von innen nicht sofort und ohne Hilfsmittel geöffnet werden kann.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.3.4': {
    was: 'Türen, Zargen und Schlossbereich auf Verformung und Aufbruchspuren prüfen.',
    achten: [
      'Hebelspuren am Schloss oder an der Zarge',
      'Verbogenes Türblatt, Spalt zur Zarge',
      'Beschädigter oder ausgetauschter Schließzylinder',
    ],
    nio: 'n.i.O., wenn Verformungen oder Einbruchspuren vorhanden sind (Betreiber zusätzlich informieren).',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.3.5': {
    was: 'Prüfen, ob ein Türfeststeller vorhanden ist und die geöffnete Tür sicher gegen Zuschlagen hält.',
    achten: [
      'Feststeller fehlt oder ist abgebrochen',
      'Tür schlägt bei Wind trotz Feststeller zu',
      'Feststeller rostig oder schwergängig',
    ],
    nio: 'n.i.O., wenn der Türfeststeller fehlt oder die Tür nicht sicher offen hält.',
    norm: 'Herstellerangaben; Gefährdungsbeurteilung',
  },
  '01-STATIONSKOERPER|01.3.6': {
    was: 'Prüfen, ob eine Doppelschließung vorhanden ist, damit der Netzbetreiber (VNB) mit eigenem Schlüssel Zutritt hat.',
    achten: [
      'Nur ein Schließzylinder, kein VNB-Schloss',
      'VNB-Zylinder vorhanden, aber defekt oder falsches Schließsystem',
    ],
    nio: 'n.i.O., wenn die vom VNB geforderte Doppelschließung fehlt oder nicht funktioniert.',
    norm: 'TAB Mittelspannung des VNB (VDE-AR-N 4110)',
  },
  '01-STATIONSKOERPER|01.3.7': {
    was: 'Prüfen, ob über den außenliegenden Schlössern Regenkappen sitzen, die Wasser und Schmutz abhalten.',
    achten: [
      'Regenkappe fehlt → „fehlt" wählen',
      'Kappe gebrochen, verbogen oder schließt nicht → „beschädigt"',
      'Wasser oder Rost im Schließzylinder',
    ],
    nio: 'n.i.O. bzw. „fehlt"/„beschädigt", wenn ein Schloss nicht durch eine intakte Regenkappe geschützt ist.',
    norm: 'Herstellerangaben',
  },

  // 01.4 Innenraum / Boden
  '01-STATIONSKOERPER|01.4.1': {
    was: 'Innenraum, Kabelkeller und Boden auf Feuchtigkeit, Kondenswasser und stehendes Wasser prüfen.',
    achten: [
      'Pfützen oder Wasser im Kabelkeller',
      'Kondenswasser an Decke, Wänden oder Anlagenteilen',
      'Rostspuren oder Tropfwasser an Schaltanlagen',
    ],
    nio: 'n.i.O., wenn im Innenraum Feuchtigkeit, Kondensat oder stehendes Wasser vorhanden ist.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); Herstellerangaben der Schaltanlage',
  },
  '01-STATIONSKOERPER|01.4.2': {
    was: 'Innenraum auf Rost und lose Bauteile (Halterungen, Abdeckungen, Kabelbahnen, Schilder) ansehen.',
    achten: [
      'Rost an Trägern, Kabelbahnen, Halterungen',
      'Lose oder herabhängende Abdeckungen und Befestigungen',
      'Herumliegende Teile oder Werkzeug',
    ],
    nio: 'n.i.O., wenn Korrosion oder lose Bauteile vorhanden sind.',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.4.3': {
    was: 'Innenraum und Kabelkeller auf Tiere und deren Spuren prüfen (Nester, Kot, Fraßspuren).',
    achten: [
      'Mäuse- oder Marderkot, Nester im Kabelkeller',
      'Angefressene Kabelisolierungen',
      'Insekten- oder Wespennester',
    ],
    nio: 'n.i.O., wenn Schädlingsbefall oder frische Spuren davon erkennbar sind.',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.4.4': {
    was: 'Trägerkonstruktion unter dem Boden und die Bodenplatten auf Tragfähigkeit und Zustand prüfen.',
    achten: [
      'Durchgebogene, gebrochene oder wackelnde Bodenplatten',
      'Rostige oder verformte Träger',
      'Fehlende Platten, offene Löcher (Stolper- und Absturzgefahr)',
    ],
    nio: 'n.i.O., wenn Bodenplatten oder Träger beschädigt, lose oder nicht sicher begehbar sind.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); Gefährdungsbeurteilung',
  },
  '01-STATIONSKOERPER|01.4.5': {
    was: 'Prüfen, ob die Bodenplatten im MS-Raum fest verschraubt sind (wichtig bei Störlichtbogen-Druck).',
    achten: [
      'Fehlende oder lose Schrauben an Bodenplatten',
      'Platten lassen sich anheben oder verschieben',
    ],
    nio: 'n.i.O., wenn Bodenplatten im MS-Raum nicht vollständig verschraubt sind.',
    norm: 'Herstellerangaben der Station; DIN EN 62271-202 (VDE 0671-202)',
  },

  // 01.5 Lüftung / Druckentlastung - seit Migration 49 EIN Punkt mit Gruenden.
  // Die Einzeltexte 01.5.1-01.5.11 darunter bleiben fuer alte Protokolle.
  '01-STATIONSKOERPER|01.5': {
    was: 'Lüftung und Druckentlastung als Ganzes prüfen: Zuluft/Abluft, Gitter, Jalousien und Klappen, Stocherschutz und Druckentlastungsweg.',
    achten: [
      'Lüftung vorhanden, Luft kann frei strömen (kein Laub, keine Fremdkörper)',
      'Gitter unbeschädigt, fest, ohne Rost; kein Tierbefall (Vorsicht Wespen)',
      'Jalousien/Klappen beweglich; Stocher-/Eindringschutz vorhanden und intakt',
      'Keine Verformung oder Einbruchspuren; Druckentlastungsweg frei',
    ],
    nio: 'n.i.O., sobald eine Sache nicht passt – dann darunter alle zutreffenden Gründe antippen.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); DIN EN 61936-1 (VDE 0101-1); Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.5.1': {
    was: 'Feststellen, ob Lüftungseinrichtungen (Lüftungsgitter, Jalousien, Lüfter) vorhanden sind. Reine Bestandsaufnahme.',
    achten: [
      'Zuluft unten und Abluft oben vorhanden?',
      'Bei „nein": Trafo-Wärme kann nicht abgeführt werden – im Bericht vermerken',
    ],
    nio: 'Kein i.O./n.i.O.: „ja" oder „nein" wählen. Bei „nein" die Folgepunkte sinngemäß beantworten.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.5.2': {
    was: 'Prüfen, ob Luft ungehindert durch die Lüftungsöffnungen strömen kann.',
    achten: [
      'Laub, Schmutz oder Spinnweben in Gittern und Filtern',
      'Bewuchs, Schnee oder abgestellte Gegenstände vor den Öffnungen',
    ],
    nio: 'n.i.O., wenn Lüftungsöffnungen teilweise oder ganz zugesetzt sind.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.5.3': {
    was: 'Lüftungsgitter auf mechanische Schäden prüfen.',
    achten: [
      'Verbogene, eingedrückte oder ausgebrochene Lamellen',
      'Löcher, durch die Tiere oder Gegenstände eindringen können',
    ],
    nio: 'n.i.O., wenn ein Lüftungsgitter mechanisch beschädigt ist.',
    norm: 'DIN EN 62271-202 (VDE 0671-202)',
  },
  '01-STATIONSKOERPER|01.5.4': {
    was: 'Lüftungsöffnungen und die Bereiche dahinter auf Tierbefall prüfen.',
    achten: [
      'Wespen- oder Hornissennester (Vorsicht beim Öffnen)',
      'Vogelnester, Federn, Kot',
      'Mäuse- oder Marderspuren hinter dem Gitter',
    ],
    nio: 'n.i.O., wenn Tiere oder Nester in oder an der Lüftung vorhanden sind.',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.5.5': {
    was: 'Bewegliche Teile der Lüftung (Jalousien, Klappen, ggf. Lüfter) auf Funktion prüfen.',
    achten: [
      'Jalousie oder Klappe blockiert, klemmt oder ist festgerostet',
      'Lüfter läuft nicht oder macht Geräusche',
    ],
    nio: 'n.i.O., wenn bewegliche Lüftungsteile blockiert, verstopft oder ohne Funktion sind.',
    norm: 'Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.5.6': {
    was: 'Lüftungsgitter und Rahmen auf Rost und feste Befestigung prüfen.',
    achten: [
      'Rost an Gitter, Rahmen oder Schrauben',
      'Gitter wackelt, lässt sich von außen herausziehen',
    ],
    nio: 'n.i.O., wenn Korrosion vorhanden ist oder die Befestigung lose ist.',
    norm: 'Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.5.7': {
    was: 'Luftweg zwischen Zuluft, Trafo und Abluft auf Fremdkörper prüfen.',
    achten: [
      'Äste, Plastiktüten, Papier im Luftkanal',
      'Eingelagertes Material, das den Luftstrom behindert',
    ],
    nio: 'n.i.O., wenn Fremdkörper im Luftweg liegen.',
    norm: 'Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.5.8': {
    was: 'Prüfen, ob hinter den Lüftungsöffnungen ein Stocher- und Eindringschutz (feines Gitter) vorhanden und intakt ist.',
    achten: [
      'Schutzgitter fehlt – Draht oder Stock könnte spannungsführende Teile erreichen',
      'Gitter eingerissen, eingedrückt oder lose',
    ],
    nio: 'n.i.O., wenn der Stocher-/Eindringschutz fehlt oder beschädigt ist.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.5.9': {
    was: 'Lüftungsgitter und Klappen auf Verformung und Aufbruchspuren prüfen.',
    achten: [
      'Aufgebogene oder herausgehebelte Gitter',
      'Werkzeugspuren an Befestigungen',
    ],
    nio: 'n.i.O., wenn Verformungen oder Einbruchspuren vorhanden sind (Betreiber informieren).',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.5.10': {
    was: 'Prüfen, ob der Druckentlastungsweg (bei Störlichtbogen) frei ist, also nichts davor oder darauf gelagert ist.',
    achten: [
      'Material, Paletten oder Fahrzeuge vor Druckentlastungsöffnungen',
      'Zugestellter Bereich über/unter der Schaltanlage (Entlastungskanal)',
    ],
    nio: 'n.i.O., wenn der Entlastungsweg verdeckt oder zugestellt ist.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); Herstellerangaben',
  },
  '01-STATIONSKOERPER|01.5.11': {
    was: 'Druckentlastungsklappen und -öffnungen auf Verformung prüfen, z. B. nach einer Druckauslösung.',
    achten: [
      'Ausgebeulte oder aufgesprungene Entlastungsklappen',
      'Rußspuren oder Brandgeruch (Hinweis auf Störlichtbogen)',
    ],
    nio: 'n.i.O., wenn eine Verformung oder ein Hinweis auf eine Druckauslösung vorhanden ist.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); Herstellerangaben',
  },

  // 01.6 Fenster / Glaselemente (invertierte Logik)
  '01-STATIONSKOERPER|01.6.1': {
    was: 'Feststellen, ob die Station Fenster, Glasbausteine oder andere Glaselemente hat.',
    achten: [
      'Auch kleine Glasbausteine im Mauerwerk mitzählen',
      'Glas kann bei Störlichtbogen-Druck brechen und Personen außen gefährden',
      'Anzahl und Lage der Glaselemente in der Bemerkung notieren',
    ],
    nio: 'Sonderfall: „vorhanden" ist ein Mangel (rot), „nicht vorhanden" ist in Ordnung. Eine Begründung ist nicht nötig.',
    norm: 'ETB-Vorgabe',
  },
  '01-STATIONSKOERPER|01.6.2': {
    was: 'Sonderfall: Hier gilt „vorhanden = Mangel". Fenster, Glasbausteine und Glaselemente sind nach ETB-Vorgabe in der Station nicht zulässig.',
    achten: [
      'Glas ist Schwachstelle bei Einbruch und Vandalismus',
      'Glas kann bei Störlichtbogen-Druck brechen und Personen außen gefährden',
      'Anzahl und Lage der Glaselemente in der Bemerkung notieren',
    ],
    nio: 'Immer „n.i.O. da nicht zulässig", sobald Glaselemente vorhanden sind.',
    norm: 'ETB-Vorgabe',
  },

  // 01.7 Beleuchtung - seit Migration 51 EIN Punkt mit Gruenden.
  // Die Einzeltexte 01.7.1-01.7.3 darunter bleiben fuer alte Protokolle.
  '01-STATIONSKOERPER|01.7': {
    was: 'Innenbeleuchtung als Ganzes prüfen: einschalten, Leuchten ansehen, Schalter und Türkontakte betätigen.',
    achten: [
      'Alle Leuchten gehen an und sind ausreichend hell (auch im Bedien- und Kabelbereich)',
      'Abdeckungen und Gehäuse vollständig, nicht gebrochen; Leuchte fest',
      'Lichtschalter und Türkontakt schalten zuverlässig',
    ],
    nio: 'n.i.O., sobald etwas davon nicht passt – dann darunter die zutreffenden Gründe antippen.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.7.1': {
    was: 'Beleuchtung in allen Räumen einschalten und prüfen, ob alle Leuchten angehen und ausreichend hell sind.',
    achten: [
      'Leuchtmittel defekt oder flackert',
      'Bedien- und Kabelbereich bleibt dunkel',
    ],
    nio: 'n.i.O., wenn eine Leuchte nicht funktioniert oder die Beleuchtung für sicheres Arbeiten nicht ausreicht.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.7.2': {
    was: 'Leuchten auf äußeren Zustand prüfen, besonders Abdeckungen, Gehäuse und Befestigung.',
    achten: [
      'Gebrochene oder fehlende Leuchtenabdeckung',
      'Wasser oder tote Insekten im Leuchtengehäuse',
      'Leuchte hängt lose',
    ],
    nio: 'n.i.O., wenn Abdeckungen fehlen oder beschädigt sind oder die Leuchte lose ist.',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.7.3': {
    was: 'Lichtschalter und Türkontaktschalter betätigen: Licht muss zuverlässig ein- und ausgehen.',
    achten: [
      'Schalter defekt, lose oder Abdeckung gebrochen',
      'Türkontakt schaltet beim Öffnen der Tür kein Licht ein',
      'Schalter nicht direkt am Eingang erreichbar',
    ],
    nio: 'n.i.O., wenn Schalter oder Türkontakte nicht zuverlässig funktionieren oder beschädigt sind.',
    norm: 'DIN VDE 0105-100',
  },

  // ───────────── 02-MS-ANLAGE ─────────────
  // Grundsatz: nur von außen ansehen. Öffnen/Schalten nur mit Befugnis und nach den fünf Sicherheitsregeln.

  '02-MS-ANLAGE|02.1': {
    was: 'Gasdruckanzeige (Manometer oder Anzeige) an gasisolierten Anlagen (SF6 oder Clean Air) ablesen.',
    achten: [
      'Zeiger im grünen Bereich? Rot oder Warnfeld = zu wenig Gas',
      'Wartungs- oder Störmeldung an der Anlage aktiv',
      'Anzeige beschädigt oder nicht ablesbar',
      'Luftisolierte Anlage ohne Gasraum → „n. benötigt"',
    ],
    nio: 'n.i.O., wenn der Gasdruck außerhalb des zulässigen Bereichs liegt oder die Wartungsanzeige anspricht – dann nicht schalten und Büro informieren.',
    norm: 'Herstellerangaben; DIN EN 62271-200 (VDE 0671-200)',
  },
  // 02.2 seit Migration 52 zusammen mit 02.3 (Isolierstoffe), Gruende bei n.i.O.
  '02-MS-ANLAGE|02.2': {
    was: 'Schaltanlagengehäuse bzw. Schrank und die sichtbaren Isolierteile (Stützer, Durchführungen, Isolierwände) prüfen – nur einsehbare Teile, nichts öffnen.',
    achten: [
      'Beulen, Risse oder Rost am Gehäuse; Tür/Abdeckung schließt und verriegelt',
      'Erdungsanschluss am Gehäuse vorhanden und fest',
      'Risse oder Ausbrüche an Isolatoren, Staub-/Feuchtebeläge, dunkle Kriechspuren',
      'Verfärbungen, Brandflecken, Geruch nach Ozon oder verschmortem Kunststoff',
    ],
    nio: 'n.i.O., sobald etwas davon zutrifft – dann darunter die Gründe antippen.',
    norm: 'DIN EN 62271-200 (VDE 0671-200); DIN VDE 0105-100; Herstellerangaben',
  },
  '02-MS-ANLAGE|02.3': {
    was: 'Sichtbare Isolierteile (Stützer, Durchführungen, Isolierwände) auf Risse, Verschmutzung und Verfärbung prüfen – nur einsehbare Teile, nichts öffnen.',
    achten: [
      'Risse oder Ausbrüche an Isolatoren',
      'Staub- oder Feuchtebeläge, dunkle Kriechspuren',
      'Verfärbungen, Brandflecken, Geruch nach Ozon oder verschmortem Kunststoff',
    ],
    nio: 'n.i.O., wenn Risse, Kriechspuren durch Verschmutzung oder Verfärbungen erkennbar sind.',
    norm: 'DIN VDE 0105-100; Herstellerangaben',
  },
  '02-MS-ANLAGE|02.4': {
    was: 'MS-Kabelanschlüsse, Endverschlüsse und Durchführungen, soweit von außen sichtbar, auf Schäden und Befestigung prüfen.',
    achten: [
      'Beschädigte Kabelmäntel oder Endverschlüsse',
      'Kabel hängt am Anschluss, fehlende Kabelschelle (Zugentlastung)',
      'Verfärbung oder Brandspuren am Anschlussbereich',
    ],
    nio: 'n.i.O., wenn Isolationsschäden, gelöste Anschlüsse oder fehlende Zugentlastung erkennbar sind.',
    norm: 'DIN VDE 0105-100; Herstellerangaben',
  },
  '02-MS-ANLAGE|02.5': {
    was: 'Sichtbare Erdungsverbindungen der MS-Anlage (Erdungsschiene, Erdungsleitungen, Kabelschirme) prüfen.',
    achten: [
      'Lose, abgerissene oder fehlende Erdungsleitungen',
      'Korrosion an Klemmen und Schienen',
      'Auffällig dünne Leitungen im Vergleich zu den übrigen Erdungen',
    ],
    nio: 'n.i.O., wenn eine Erdungsverbindung lose, korrodiert, unterbrochen oder erkennbar zu schwach ist.',
    norm: 'DIN EN 50522 (VDE 0101-2); DIN EN 61936-1 (VDE 0101-1)',
  },
  '02-MS-ANLAGE|02.6': {
    was: 'Stellungsanzeigen von Lasttrennschaltern, Erdern und Leistungsschaltern sowie Ausgelöst-Meldungen ablesen und mit dem tatsächlichen Schaltzustand vergleichen.',
    achten: [
      'Anzeige passt nicht zum erwarteten Schaltzustand (z. B. laut Schaltplan)',
      'Anzeigefenster verschmutzt, gebrochen oder unleserlich',
      'Ausgelöst-Meldung steht an (Ursache klären, nicht einfach zurücksetzen)',
    ],
    nio: 'n.i.O., wenn eine Anzeige unklar, falsch, beschädigt oder mechanisch ohne Funktion ist.',
    norm: 'DIN EN 62271-200 (VDE 0671-200); DIN VDE 0105-100',
  },
  '02-MS-ANLAGE|02.7': {
    was: 'Gängigkeit der Schaltmechanik beurteilen. Schalthandlungen nur mit Befugnis, Freigabe und nach Schaltauftrag.',
    achten: [
      'Antrieb schwergängig oder verklemmt',
      'Schalthebel lässt sich nicht einsetzen oder rastet nicht ein',
      'Verriegelungen (z. B. Erder/Trenner) funktionieren nicht',
    ],
    nio: 'n.i.O., wenn ein Schalter schwergängig ist, klemmt oder eine Verriegelung versagt.',
    norm: 'DIN VDE 0105-100; Herstellerangaben',
  },
  '02-MS-ANLAGE|02.8': {
    was: 'Schutz- und Anzeigegeräte (Kurzschlussanzeiger, Spannungsmonitoring, UMZ-/Differentialschutz, Manometer) auf sichtbare Schäden prüfen.',
    achten: [
      'Glasbruch oder gesprungenes Display',
      'Gerät ohne Anzeige, Fehler- oder Störungs-LED leuchtet',
      'Kurzschlussanzeiger hat angesprochen (Ereignis im Bericht notieren)',
    ],
    nio: 'n.i.O., wenn ein Schutz- oder Anzeigegerät sichtbar beschädigt ist oder eine Störung meldet.',
    norm: 'Herstellerangaben; DIN VDE 0105-100',
  },
  '02-MS-ANLAGE|02.9': {
    was: 'Prüfen, ob jedes MS-Schaltfeld geerdet werden kann (eingebauter Erdungsschalter oder Anschlusspunkte für Erdungsgarnitur).',
    achten: [
      'Schaltfeld ohne Erdungsschalter und ohne Kugelfestpunkte',
      'Erdungsschalter vorhanden, aber defekt oder nicht bedienbar',
    ],
    nio: 'n.i.O., wenn ein Schaltfeld nicht sicher geerdet und kurzgeschlossen werden kann.',
    norm: 'DIN VDE 0105-100 (fünf Sicherheitsregeln); DIN EN 61936-1 (VDE 0101-1)',
  },
  '02-MS-ANLAGE|02.10': {
    was: 'Prüfen, ob beim Auslösen einer HH-Sicherung der Schlagstift den Trafoschalter allseitig ausschaltet. Nur mit Befugnis im freigeschalteten Feld.',
    achten: [
      'Auslösemechanik schwergängig oder blockiert',
      'Falsche HH-Sicherung ohne passenden Schlagstift eingesetzt',
      'Feld ohne HH-Sicherungen (z. B. Leistungsschalter) → „n. benötigt"',
    ],
    nio: 'n.i.O., wenn die Schlagstiftauslösung den Trafoschalter nicht zuverlässig auslöst.',
    norm: 'DIN 43625 (HH-Sicherungen); Herstellerangaben',
  },
  '02-MS-ANLAGE|02.11': {
    was: 'Prüfen, ob beim Ausschalten/Auslösen des MS-Trafoschalters der zugehörige NS-Leistungsschalter des Trafos mit abschaltet (Mitnahme).',
    achten: [
      'NS-Leistungsschalter bleibt eingeschaltet',
      'Mitnahmeleitung oder Hilfskontakt fehlt bzw. ist nicht angeschlossen',
      'Keine Mitnahme vorgesehen (z. B. kein NS-Leistungsschalter) → „n. benötigt"',
    ],
    nio: 'n.i.O., wenn die vorgesehene Mitnahme des NS-Leistungsschalters nicht funktioniert.',
    norm: 'Schutzkonzept der Anlage; Herstellerangaben',
  },
  '02-MS-ANLAGE|02.12': {
    was: 'Baujahr der MS-Schaltanlage vom Typenschild ablesen und prüfen, ob sie 30 Jahre oder älter ist (Lebensdauer nach AMEV/VDI/HEA).',
    achten: [
      'Baujahr steht auf dem Typenschild, sonst in Unterlagen nachsehen',
      'Ersatzteilversorgung beim Hersteller eingestellt?',
    ],
    nio: 'Kein i.O./n.i.O.: „ja" bei 30 Jahren oder älter (Erneuerung empfehlen), sonst „nein".',
    norm: 'AMEV / VDI / HEA',
  },

  // ───────────── 03-NSHV ─────────────

  '03-NSHV|03': {
    was: 'Feststellen, ob die Station eine eigene Niederspannungs-Hauptverteilung (NSHV) hat.',
    achten: [
      '„vorhanden": dann erscheinen die Prüfpunkte zur NSHV',
      '„nicht vorhanden": keine weiteren Fragen, weiter mit dem Trafo – das ist kein Mangel',
    ],
    nio: 'Kein i.O./n.i.O. – nur Bestandsaufnahme.',
    norm: '–',
  },

  '03-NSHV|03.1': {
    was: 'Funktion und Zustand der NS-Schaltgeräte (Leistungsschalter, Lasttrenner, Sicherungsleisten) beurteilen. Schalten nur mit Befugnis und Absprache.',
    achten: [
      'Schaltgerät schwergängig, klemmt oder rastet nicht ein',
      'Brandspuren, Verfärbung oder Geruch an Geräten und Anschlüssen',
      'Fehlende Abdeckungen oder Berührungsschutz',
      'Ausgelöste oder falsch bestückte Sicherungen',
    ],
    nio: 'n.i.O., wenn ein Schaltgerät nicht einwandfrei funktioniert oder sichtbar beschädigt ist.',
    norm: 'DIN VDE 0105-100; DIN EN 61439-1/-2 (VDE 0660-600)',
  },
  '03-NSHV|03.2': {
    was: 'Einstellwerte am NS-Leistungsschalter des Trafos ablesen und mit dem Nennstrom des Trafos (Typenschild) vergleichen.',
    achten: [
      'Überlast-Einstellung (Ir) passt nicht zum Trafo-Nennstrom',
      'Einstellrad nicht plombiert oder nicht ablesbar',
      'Trafo-Nennstrom unbekannt → Typenschild fotografieren',
    ],
    nio: 'Kein i.O./n.i.O.: „nein" wählen, wenn die Einstellung nicht zum Trafo-Nennstrom passt.',
    norm: 'DIN VDE 0100-430; Herstellerangaben',
  },
  '03-NSHV|03.3': {
    was: 'Baujahr der NS-Schaltanlage ablesen und prüfen, ob sie 25 Jahre oder älter ist.',
    achten: [
      'Baujahr auf Typenschild oder in der Anlagendokumentation',
      'Veraltete Bauweise, z. B. offene Sammelschienen ohne Berührungsschutz',
    ],
    nio: 'Kein i.O./n.i.O.: „ja" bei 25 Jahren oder älter (Erneuerung empfehlen), sonst „nein".',
    norm: 'AMEV / VDI / HEA',
  },
  '03-NSHV|03.4': {
    was: 'Prüfen, ob ein Überspannungsschutz (SPD) eingebaut ist. Nur bei „ja" folgen die Fragen zu Absicherung und Anschluss.',
    achten: [
      'Kein Überspannungsschutz vorhanden → „nein" (Mangel)',
      'Statusanzeige rot oder Schutzmodul ausgelöst → bei 03.6 als n.i.O. vermerken',
    ],
    nio: '„nein" ist ein Mangel. „ja" heißt nur: vorhanden – Zustand und Anschluss folgen.',
    norm: 'DIN VDE 0100-534; DIN VDE 0100-443',
  },
  '03-NSHV|03.5': {
    was: 'Prüfen, ob die Vorsicherung des Überspannungsschutzes den Herstellerangaben entspricht (Größe und Art).',
    achten: [
      'Sicherungswert größer als vom Hersteller zugelassen',
      'Keine Vorsicherung, obwohl der Hersteller eine fordert',
      'Datenblatt nicht vorhanden → Typ notieren, Büro prüft nach',
    ],
    nio: 'n.i.O., wenn die Absicherung nicht den Herstellervorgaben entspricht.',
    norm: 'Herstellerangaben; DIN VDE 0100-534',
  },
  '03-NSHV|03.6': {
    was: 'Anschluss des Überspannungsschutzes prüfen: Leiterquerschnitte, feste Klemmen und möglichst kurze Anschlussleitungen, besonders zum PE.',
    achten: [
      'Gesamtlänge der Anschlussleitungen über 0,5 m → „PE-Anschluss >0,5m"',
      'Typ passt nicht zum Einbauort (z. B. nur Typ 3 statt Typ 1/2) → „falscher Typ"',
      'Statusanzeige rot oder Schutzmodul ausgelöst',
      'Leitungen mit Schleifen statt kurz und gerade verlegt',
      'Lose Klemmen, zu kleiner Querschnitt',
    ],
    nio: 'n.i.O., wenn der Anschluss nicht nach Herstellerangaben und DIN VDE ausgeführt ist.',
    norm: 'DIN VDE 0100-534; Herstellerangaben',
  },
};
